import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { set, useForm } from "react-hook-form";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"
const Option = (props) => {
  return (
      <div>
          {
              //console.log("results=="+JSON.stringify(props))
          }
          <components.Option {...props}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
              />{" "}
              <label>{props.label}</label>
          </components.Option>
      </div>
  );
};

const ProfileReport: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 50; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [jobfilterlist, setJobFilterList] = useState([]);
      const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educationsval, setEducation] = useState([]);
  const [educations, setEducations] = useState([]);
  const [categories, setCategory] = useState([]);
  const [muljobTypes, setMulJobTypes] = useState([]);
  const [optionSelected_d, setoptionSelectedd] = useState(null);
  const [jobtypeRequestArray_d, setJobTypeRequestArrayd] = useState([]);
  const [mulcategories_d, setMulCategory_d] = useState([]);
  const [industryRequestArray_d, setIndustryRequestArrayd] = useState([]);
  const [optionCatSelected_d, setoptionCatSelectedd] = useState(null);
  const [muleducation, setMulEducationTypes] = useState([]);
  const [eduRequestArray_d, setEduTypeRequestArrayd] = useState([]);
  const [optionEduSelected_d, setoptionEduSelectedd] = useState(null);
  const [educationRequestArray_d, setEducationRequestArrayd] = useState([]);
  const [optionEducationSelected_d, setoptionEducationSelectedd] = useState(null);

  const [reportStatus, setReportStatus] = useState('');
  const [reportIndustry, setReportIndustry] = useState('');
  const [reportEducation, setReportEducation] = useState('');
  const [reportJobtype, setReportJobtype] = useState('');
  const [runReport, setRunReport] = useState(0);
  var FileSaver = require('file-saver');

  var industry_webvar = [];
  var jobtype_webvar = [];
  var education_webvar = [];

      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all", mode: "onBlur"
      });

      const handleChangeForCate_d = (selected) => {
        //alert();
        var dummArray = [];
        var dummArray_label = '';
        for (var i = 0; i < selected.length; i++) {
            //alert(selected[i].label.toString());
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            } else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            industry_webvar.push(selected[i].value.toString());
        }
        setIndustryRequestArrayd(dummArray);
        //industry_webvar = dummArray;
        $('#industry_selected').val(JSON.stringify(dummArray));
        $('#industry_selfilter').val(dummArray_label);
        setoptionCatSelectedd(selected);
        setReportIndustry(dummArray_label);
    };

      useEffect(() =>
      {
        getIndustryData();
        $(".load-wrap").hide();
        services.getLocationCounty().then((res) => {
          console.log("getLocationCounty data=" + JSON.stringify(res.data));
          setLocationCounty(res.data.content);
        });
        services.getJobType().then((res) => {
          var jobtype_unsort = res.data.content;

          jobtype_unsort = jobtype_unsort.filter(function(elem) {
            return elem.name !== 'Job Shadow';
          });
          jobtype_unsort = jobtype_unsort.filter(function (elem) {
            return elem.name !== 'Continuing Education';
          });
          var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
          array_move(jobtypes_sorted, 0, (jobtypes_sorted.length-1));
          setJobType(jobtypes_sorted);
          var dummArray = [];
            for (var i = 0; i < jobtype_unsort.length; i++) {
                dummArray.push({ "label": jobtype_unsort[i].name, "value": jobtype_unsort[i].jobTypeId })
            }
            setMulJobTypes(dummArray)

        });
        services.getEducation().then((res) => {
          console.log("getEducation data=" + JSON.stringify(res.data));
          setEducation(res.data.content);
        });
       // getProfilelist(ITEMS_PER_PAGE,'1');
        services.getEducation().then((res) => {
          //console.log("getEducation data=" + JSON.stringify(res.data));
          setEducations(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].educationId })
          }
          setMulEducationTypes(dummArray)

      });
      setReportStatus('No');
      },[]);

      const handleChange_d = (selected) => {
        var dummArray = [];
        var dummArray_label = '';
        console.log(selected);
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            }
            else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            jobtype_webvar.push(selected[i].value.toString());
        }
        console.log(dummArray);
        setoptionSelectedd(selected);
        //jobtype_webvar = dummArray;
        $('#jobtype_selected').val(JSON.stringify(dummArray));
        $('#jobtype_selfilter').val(dummArray_label);
        setJobTypeRequestArrayd(dummArray);
        setReportJobtype(dummArray_label);
    };

    const handleChangeForEdu_d = (selected) => {

      var dummArray = [];
      var dummArray_label = '';
      for (var i = 0; i < selected.length; i++) {
          //alert(selected[i].label.toString());
          dummArray.push(selected[i].value.toString());
          if(i==0){
            dummArray_label = selected[i].label.toString();
          }
          else{
            dummArray_label = dummArray_label+', '+selected[i].label.toString();
          }
          education_webvar.push(selected[i].value.toString());
      }
      setEducationRequestArrayd(dummArray);
      //industry_webvar = dummArray;
      $('#education_selected').val(JSON.stringify(dummArray));
      $('#education_selfilter').val(dummArray_label);
      setoptionEducationSelectedd(selected);
      setReportEducation(dummArray_label);
};

      function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

      const getIndustryData = () => {
        services.getIndustryData().then((res) => {
          setCategory(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
          }
          setMulCategory_d(dummArray)
        });
      }
      const submitValue = () => {
        getProfilelist(ITEMS_PER_PAGE,'1');
      }
      const searchList = () => {
        getProfilelist(ITEMS_PER_PAGE,'1');
      }

      const handlePageChange2 = (offset,triggerevent) => {
        getProfilelist(ITEMS_PER_PAGE,offset);
      };

      function validateCheck() {

    }

    const filterContent_full = () => {

      var industries_filter:any = [];
      var selected_ind:any = $('#industry_selected').val();
      if (selected_ind != '') {
          var industries_filter = JSON.parse(selected_ind);
      }

      var jobtypes_filter:any = [];
      var selected_types:any = $('#jobtype_selected').val();
      if (selected_types != '') {
          var jobtypes_filter = JSON.parse(selected_types);
      }

      var education_filter:any = [];
      var selected_education:any = $('#education_selected').val();
      if (selected_education != '') {
          var education_filter = JSON.parse(selected_education);
      }

      //setReportJobtype($('#jobtype_selfilter').val());
      //setReportEducation($('#education_selfilter').val());
      //setReportIndustry($('#industry_selfilter').val());

if($('#archived_resumes').val() == 1){
  setReportStatus('Yes');
}
else {
  setReportStatus('No');
}

//setReportStatus(statusval);
var archres:any = $('#archived_resumes').val();
      const requestObject = {
          "siteId": 2,
          "categoriesOfExpertise": industries_filter,
          "levelOfEducation":education_filter,
          "type": jobtypes_filter,
          "searchTxt": $('#job_title').val(),
            "titleSummary": $('#job_title').val(),
          "pageNumber": 1,
          "pageSize": 50000,
          "sortBy": "",
          "sortDir" : "",
          "archivedResumes": parseInt(archres)
      }

      // console.log(JSON.stringify(objInputAvailableJobs));
      var accessTokenIn = sessionStorage.getItem("adminAccToken");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "+accessTokenIn
          //'Authorization': accessTokenIn
        },
        body: JSON.stringify(requestObject)
      };
      $(".load-wrap").show();
      services.getProfileReportList(requestOptions).then((res) => {
       // console.log(JSON.stringify(res.content))
        if (res) {

              var contAr = res.content;

              //setJobFilterList(res.content);
                download_excel(contAr);
         }

      });

  }

  function download_excel(profileListFull){
    //console.log(profileListFull);

    var today = new Date();
    var month = today.toLocaleString('en-US', {month: 'short'});
    var date= today.getDate();
    var year = today.getFullYear();

    var filename = "Job Seeker-export-"+month+"-"+date+"-"+year+".csv";
   // console.log(filename);
    let csv = '';
    let row = '';
    let headers = '';


    var row2 = '';
    if (reportJobtype != '') 
        row2 = row2+' Job Type : '+reportJobtype.replace(/,/g, ";");

    if(reportJobtype != '' && reportEducation != '')
        row2 = row2+';      '; 

    if (reportEducation != '') 
        row2 = row2+'Level Of Education Completed : '+reportEducation.replace(/,/g, ";");

    if(reportEducation != '' && reportIndustry != '')
        row2 = row2+';      ';    

    if (reportIndustry != '') 
        row2 = row2+'Categories of Interest : '+reportIndustry.replace(/,/g, ";");

    if(reportIndustry != '' && reportStatus != '')
        row2 = row2+';      ';     

    if (reportStatus != '') 
        row2 = row2+'Show Archived Resumes : '+reportStatus.replace(/,/g, ";");
console.log(reportStatus);
    var jobtypeslisthead = 'Job Seekers Report'+',';
  var jobtypeslisthead = jobtypeslisthead+'\n'+row2+',';
   var jobtypeslisthead = jobtypeslisthead+'\n'+'Name'+','+'Email'+','+'Phone'+','+'Education'+','+'Status'+',';

    headers = headers.concat(jobtypeslisthead);

    csv = csv.concat(headers);
    row = '';

    //alert(profileListFull.length);
    for(var i=0; i<profileListFull.length; i++){

            var jobtypeslistrow = "";
            var cats = profileListFull[i].categoryName;

            var selectedcategs = cats.join('; ');

            var firstname  = profileListFull[i].firstName;
            var fname = firstname.replace(/,/g, ";");

            var lastname  = profileListFull[i].lastName;
            var lname = lastname.replace(/,/g, ";");

            var emailid  = profileListFull[i].email;
            var email = emailid.replace(/,/g, ";");

            if(profileListFull[i].phoneno == '0000000000' || profileListFull[i].phoneno == '0'){
              var phone = '000-000-0000';
            }
            else {
              var phone:string = profileListFull[i].phoneno;
            }

            if(profileListFull[i].levelOfEductionName == null || profileListFull[i].levelOfEductionName == ''){
              var education = '--';
            }
            else {
              var education:string = profileListFull[i].levelOfEductionName;
            }

           jobtypeslistrow = "\n"+fname+" "+lname+','+email+','+phone+','+education+','+profileListFull[i].status+',';


        row = row.concat(jobtypeslistrow);

    }
    csv = csv.concat(row);

    var file = new File([csv], filename, {type: "application/csv"});
    FileSaver.saveAs(file);
    $(".load-wrap").hide();
  }

      const getProfilelist = (ITEMS_PER_PAGE,pageNumber) => {

        var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            var industries_filter:any = JSON.parse(selected_ind);
        }

        var jobtypes_filter:any = [];
        var selected_types:any = $('#jobtype_selected').val();
        if (selected_types != '') {
            var jobtypes_filter = JSON.parse(selected_types);
        }

        var education_filter:any = [];
        var selected_education:any = $('#education_selected').val();
        if (selected_education != '') {
            var education_filter = JSON.parse(selected_education);
        }

        //setReportJobtype($('#jobtype_selfilter').val());
        //setReportEducation($('#education_selfilter').val());
 //setReportIndustry($('#industry_selfilter').val());
if($('#archived_resumes').val() == 1){
  setReportStatus('Yes');
}
else {
  setReportStatus('No');
}
setRunReport(1);
var archresume:any = $('#archived_resumes').val()
var archresume_in:any = parseInt(archresume);
        const requestObject = {
            "siteId": 2,
            "categoriesOfExpertise": industries_filter,
            "levelOfEducation":education_filter,
            "type": jobtypes_filter,
            "searchTxt": $('#job_title').val(),
            "titleSummary": $('#job_title').val(),
            "pageNumber": pageNumber,
            "pageSize": ITEMS_PER_PAGE,
            "sortBy": "",
            "sortDir" : "",
            "archivedResumes": archresume_in
        }

        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        $(".load-wrap").show();
        services.getProfileReportList(requestOptions).then((res) => {
          console.log(JSON.stringify(res.content))
          if (res) {
            //console.log(res.data);
              // $(".paginationContent").show();
               setTotalItems(res.totalElements);
               settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
               setCurrentPage(pageNumber);

               var contAr = res.content;
               //setProfileList(res.content);
               if(res){
                 setJobFilterList(res.content);
               }
               $(".load-wrap").hide();
          }

        });
}

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Job Seekers Report'})}</PageTitle>


        <div>

      {/* begin::Body */}
      <div>
        {/* begin::Table container */}
        <div className='table-responsive ofx-hidden'>


        <form onSubmit={handleSubmit(submitValue)}>
        <div>
          <div className="row">
          <div className="col-lg-12 d-none">
              <div className="mb-10">
              <div className="d-flex justify-content-end">
                    <button type="button" onClick={filterContent_full} className="btn btn-primary ml-2 mb-10" style={{ minWidth: "160px" }}>Export to Excel</button>
                  </div>
              </div>
            </div>

            <div className="col-lg-12 d-none">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Keyword Search</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder="Search By Name/ Email"  />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Job Type</label>

                </div>
                <ReactSelect
                        //className="form-select"
                        options={muljobTypes}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChange_d}
                       // allowSelectAll={true}
                        value={optionSelected_d}
                    />
                    <input type="hidden" id="jobtype_selected" />
                    <input type="hidden" id="jobtype_selfilter" />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Level Of Education Completed</label>

                </div>
                <input type="hidden" id="education_selected" />
                <input type="hidden" id="education_selfilter" />
                <ReactSelect
                        //className="form-select"
                        options={muleducation}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChangeForEdu_d}
                        //allowSelectAll={true}
                        value={optionEducationSelected_d}
                    />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Categories Of Interest</label>

                </div>
                <input type="hidden" id="industry_selected" />
                <input type="hidden" id="industry_selfilter" />
                <ReactSelect
                     // className="form-select"
                      options={mulcategories_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForCate_d}
                     //allowSelectAll={false}
                      value={optionCatSelected_d}
                      defaultValue={['1']}
                  />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Show Archived Resumes</label>

                </div>
                <select className="form-select" id="archived_resumes" name="archived_resumes" aria-label="Select example" >
                  <option value="1">Yes</option>
                  <option selected value="0">No</option>
                </select>

              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <div className="d-block">
                    <button type="submit" className="btn btn-primary ml-2 mb-10" style={{ maxWidth: "200px" }}>Run Report</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>
          {/* begin::Table */}
          <div className="card">
            <div className="card-body px-2 pt-0">
            <div className="d-flex justify-content-end text-right">
           <div className={runReport == 1 ? "tag-wrp" : "tag-wrp d-none"}>
                <div className={reportJobtype != '' ? "tag-inn" : ''}><label>{reportJobtype != '' ? 'Job Type : ' : '' }</label>{reportJobtype != '' ? reportJobtype : '' }</div>

                <div className={reportEducation != '' ? "tag-inn" : ''}><label>{reportEducation != '' ? 'Level of Education Completed : ' : '' }</label>{reportEducation != '' ? reportEducation : '' }</div>

                <div className={reportIndustry != '' ? "tag-inn" : ''}><label>{reportIndustry != '' ? 'Categories of Interest : ' : '' }</label>{reportIndustry != '' ? reportIndustry : '' }</div>

                <div className={reportStatus != '' ? "tag-inn" : ''}><label>{reportStatus != '' ? 'Show Archived Resumes : ' : '' }</label>{reportStatus != '' ? reportStatus : '' }</div>
            </div>
           <button type="button" onClick={filterContent_full} className="btn btn-primary my-2 align-self-center" style={{ minWidth: "160px", marginLeft:"auto" }}> Export to Excel</button>
           </div>

            {/* <div className="new-scrl-tbl">
            <div className="dummy"></div>
           </div> */}
              <div className="new-scrl-tbl2">
                <div>

          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 wid'>
            {/* begin::Table head */}
            <thead>
            {/* <tr>
                <td colSpan={'5'}>
                {reportJobtype != '' ? 'Job Type : '+reportJobtype : '' }
                {reportEducation != '' ? ', Level of Education Completed : '+reportEducation : '' }
                {reportIndustry != '' ? ', Categories of Interest : '+reportIndustry : '' }
                {reportStatus != '' ? ', Show Archived Resumes : '+reportStatus : '' }
                </td>
              </tr> */}

              <tr className='fw-bolder text-muted'>

                <th>Name</th>
                {/*<th>City</th>
                <th>State</th>
                <th>Zip</th> */}
                <th>Email</th>
                <th>Phone</th>
                <th>Education</th>
                <th>Status</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

         {
	          jobfilterlist.map((data, index) => (
              <tr className="fw-bolder">

                <td style={{minWidth:"150px", maxWidth:"150px", verticalAlign:"baseline"}}>{data.firstName+' '+data.lastName}</td>
               {/*} <td>{data.email}</td>
                <td>{data.email}</td>
                <td>{data.email}</td> */}
                <td style={{minWidth:"150px", maxWidth:"150px", verticalAlign:"baseline"}}>{data.email}</td>
                <td style={{minWidth:"80px", maxWidth:"80px",verticalAlign:"baseline"}}>{data.phoneno}</td>
                <td style={{minWidth:"120px", maxWidth:"150px",verticalAlign:"baseline"}}>{(data.levelOfEductionName == null || data.levelOfEductionName == '') ? '--' : data.levelOfEductionName}</td>
                <td style={{minWidth:"70px", maxWidth:"70px",verticalAlign:"baseline"}}>{data.status}</td>

              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table>
          </div></div>

          <span className="mb-2 d-block"></span>

          <Pagination

                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
                </div></div>

          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      <section className="load-wrap">
          <div className="loadingIcon">
            <img src="/media/icons/duotune/general/loading.gif" className="m-auto"></img>
            <span>Loading... <br /> please be patient..</span>
             </div>
        </section>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {ProfileReport}